import api from './axiosInstance';

export const getMonitoringPaged = {
  getPaged: async ({
    page = 1,
    pageSize = 20,
    search = null,
    sortBy = null,
    desc = true,
    userId = null,
    tribunal,
    isManaged = null,
    startDate = null,
    endDate = null,
  }) => {
    const params = new URLSearchParams();

    params.append('page', page);
    params.append('pageSize', pageSize);

    if (search) params.append('search', search);
    if (userId) params.append('userId', userId);
    if (sortBy) params.append('sortBy', sortBy);
    params.append('desc', desc);

    if (tribunal) params.append('tribunal', tribunal);
    params.append('isManaged', isManaged);

    params.append('startDate', startDate ?? '');
    params.append('endDate', endDate ?? '');

    const response = await api.get(
      `/pjud-monitoring-client/monitoring-rut?${params.toString()}`
    );

    return response.data;
  },
};

export const getPjudMonitoringClientStats = {
  getMonitoringStats: async () => {
    try {
      const response = await api.get(
        `/pjud-monitoring-client/monitoring-rut/stats`,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      return response.data;
    } catch (error) {
      error.customMessage =
        'No se pudo obtener la información solicitada. Intenta nuevamente.';
      throw error;
    }
  },
};

export const putPjudMonitoringClientOption = {
  putMonitoringOption: async (id, optionId = 12, userId) => {
    try {
      const payload = { monitoringOptionId: optionId, userId };

      const response = await api.put(
        `/pjud-monitoring-client/monitoring-rut/${id}/option`,
        payload,
        {
          headers: { 'Content-Type': 'application/json' },
        }
      );

      return response.data;
    } catch (error) {
      error.customMessage =
        'No se pudo actualizar el estado. Intenta nuevamente.';
      throw error;
    }
  },
};
